var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"logo",attrs:{"aria-label":_vm.$config.WEBSITE_NAME,"to":_vm.localePath({ name: 'index' })}},[_c('img',{attrs:{"src":"/images/logo.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }